import {
  SET_ACTIVITIES,
  ADD_ACTIVITY,
  UPDATE_ACTIVITY,
  REMOVE_ACTIVITY,
} from "../constants/activities";

const initialState = {
  activities: {},
  loaded: false,
};

export default (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case SET_ACTIVITIES: {
      const { activities } = action;
      // Convert array to object keyed by activityId
      const activitiesMap = {};
      activities.forEach((activity) => {
        activitiesMap[activity.activityId] = activity;
      });
      return {
        ...state,
        activities: activitiesMap,
        loaded: true,
      };
    }
    case ADD_ACTIVITY: {
      const { activity } = action;
      return {
        ...state,
        activities: {
          ...state.activities,
          [activity.activityId]: activity,
        },
      };
    }
    case UPDATE_ACTIVITY: {
      const { activityId, updates } = action;
      const existingActivity = state.activities[activityId];
      if (!existingActivity) return state;
      return {
        ...state,
        activities: {
          ...state.activities,
          [activityId]: {
            ...existingActivity,
            ...updates,
          },
        },
      };
    }
    case REMOVE_ACTIVITY: {
      const { activityId } = action;
      const { [activityId]: removed, ...remainingActivities } =
        state.activities;
      return {
        ...state,
        activities: remainingActivities,
      };
    }
    default:
      return state;
  }
};
